import { render, staticRenderFns } from "./DrugName.vue?vue&type=template&id=622d7670&scoped=true&"
import script from "./DrugName.vue?vue&type=script&lang=ts&"
export * from "./DrugName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d7670",
  null
  
)

export default component.exports